import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faContactBook,
  faGear,
  faHome,
  faShoppingCart,
  faUsers,
  faRightFromBracket,
  faXmark
} from "@fortawesome/free-solid-svg-icons";
import { Input, message, Modal, Tooltip, Popconfirm } from "antd";
import { API } from "../../../setup/setupAxios";
import "../../../assets/css/design/main/sidebar/adminLayout.css";

const Sidebar = ({
  nickname,
  onLogout,
  roleAccess,
  username,
  mobileOpen = false,
  setMobileOpen,
  collapsed = false
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [loadingPassword, setLoadingPassword] = useState(false);

  const handleNavClick = () => {
    if (setMobileOpen) {
      setMobileOpen(false);
    }
  };

  const handlePasswordUpdate = async () => {
    if (!password || password.trim() === "") {
      message.warning("Password baru tidak boleh kosong");
      return;
    }

    try {
      setLoadingPassword(true);
      const payload = {
        password: password
      };
      await API.patch(`/api/admin/${username}`, payload);
      message.success("Password berhasil diperbarui");
      setModalVisible(false);
      setPassword("");
    } catch (error) {
      message.error("Gagal mengganti password");
      console.error(error);
    } finally {
      setLoadingPassword(false);
    }
  };

  return (
    <>
      {/* Backdrop for mobile drawer */}
      {mobileOpen && (
        <div
          className="admin-sidebar-backdrop"
          onClick={() => setMobileOpen && setMobileOpen(false)}
        />
      )}

      {/* Main Sidebar */}
      <aside
        className={`admin-sidebar ${collapsed ? "collapsed" : ""} ${mobileOpen ? "mobile-open" : ""
          }`}
      >
        {/* Header / Brand */}
        <div className="admin-sidebar-header">
          <NavLink
            to="/admin/dashboard"
            className="admin-sidebar-brand"
            onClick={handleNavClick}
          >
            <img
              alt="Indak"
              className="admin-sidebar-logo"
              src={require("../../../assets/img/indak-company2.jpg")}
            />
            <div className="admin-sidebar-brand-text">
              <span className="admin-sidebar-brand-name">INDAK</span>
              <span className="admin-sidebar-brand-badge">Admin Portal</span>
            </div>
          </NavLink>

          {/* Close button on mobile */}
          <button
            className="admin-sidebar-close-btn"
            onClick={() => setMobileOpen && setMobileOpen(false)}
            aria-label="Tutup Menu"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        {/* Navigation Menu */}
        <nav className="admin-sidebar-nav">
          <div className="admin-sidebar-section-title">Main Navigation</div>

          <Tooltip title={collapsed ? "Dashboard" : ""} placement="right">
            <NavLink
              to="/admin/dashboard"
              className={({ isActive }) =>
                `admin-nav-item ${isActive ? "active" : ""}`
              }
              onClick={handleNavClick}
            >
              <span className="admin-nav-icon">
                <FontAwesomeIcon icon={faHome} />
              </span>
              <span className="admin-nav-text">Dashboard</span>
            </NavLink>
          </Tooltip>

          <Tooltip title={collapsed ? "Data Barang" : ""} placement="right">
            <NavLink
              to="/admin/list-barang"
              className={({ isActive }) =>
                `admin-nav-item ${isActive ? "active" : ""}`
              }
              onClick={handleNavClick}
            >
              <span className="admin-nav-icon">
                <FontAwesomeIcon icon={faShoppingCart} />
              </span>
              <span className="admin-nav-text">Data Pengiriman</span>
            </NavLink>
          </Tooltip>

          <Tooltip title={collapsed ? "Data Customer" : ""} placement="right">
            <NavLink
              to="/admin/list-customer"
              className={({ isActive }) =>
                `admin-nav-item ${isActive ? "active" : ""}`
              }
              onClick={handleNavClick}
            >
              <span className="admin-nav-icon">
                <FontAwesomeIcon icon={faUsers} />
              </span>
              <span className="admin-nav-text">Data Customer</span>
            </NavLink>
          </Tooltip>

          {(roleAccess === "Master" || roleAccess === "DBA") && (
            <Tooltip title={collapsed ? "Staff Admin" : ""} placement="right">
              <NavLink
                to="/admin/list-karyawan"
                className={({ isActive }) =>
                  `admin-nav-item ${isActive ? "active" : ""}`
                }
                onClick={handleNavClick}
              >
                <span className="admin-nav-icon">
                  <FontAwesomeIcon icon={faContactBook} />
                </span>
                <span className="admin-nav-text">Staff Admin</span>
              </NavLink>
            </Tooltip>
          )}

          <div
            className="admin-sidebar-section-title"
            style={{ marginTop: "12px" }}
          >
            System
          </div>

          <Tooltip title={collapsed ? "Ganti Password" : ""} placement="right">
            <button
              type="button"
              className="admin-nav-item"
              onClick={() => {
                setModalVisible(true);
                if (setMobileOpen) setMobileOpen(false);
              }}
            >
              <span className="admin-nav-icon">
                <FontAwesomeIcon icon={faGear} />
              </span>
              <span className="admin-nav-text">Ganti Password</span>
            </button>
          </Tooltip>
        </nav>

        {/* User Profile & Logout Footer */}
        <div className="admin-sidebar-footer">
          <div className="admin-user-card">
            <div className="admin-user-info-group">
              <img
                src={`https://api.dicebear.com/7.x/bottts/svg?seed=${nickname || username || "Admin"
                  }`}
                alt="Profile"
                className="admin-user-avatar"
              />
              <div className="admin-user-text">
                <span className="admin-user-name">
                  {nickname || username || "Admin"}
                </span>
                <span className="admin-user-role-badge">
                  {roleAccess || "Admin"}
                </span>
              </div>
            </div>

            <Popconfirm
              title="Keluar Akun"
              description="Apakah Anda yakin ingin keluar?"
              onConfirm={onLogout}
              okText="Ya, Keluar"
              cancelText="Batal"
              placement="topRight"
            >
              <Tooltip title="Keluar">
                <button
                  type="button"
                  className="admin-logout-btn"
                  aria-label="Logout"
                >
                  <FontAwesomeIcon icon={faRightFromBracket} />
                </button>
              </Tooltip>
            </Popconfirm>
          </div>
        </div>
      </aside>

      {/* Password Change Modal */}
      <Modal
        title="Ganti Password Akun"
        open={modalVisible}
        onCancel={() => {
          setModalVisible(false);
          setPassword("");
        }}
        onOk={handlePasswordUpdate}
        confirmLoading={loadingPassword}
        okText="Simpan Password"
        cancelText="Batal"
        centered
      >
        <div style={{ padding: "16px 0" }}>
          <label
            style={{
              display: "block",
              marginBottom: "8px",
              fontWeight: 500,
              fontSize: "14px",
              color: "#334155"
            }}
          >
            Password Baru
          </label>
          <Input.Password
            placeholder="Masukkan password baru Anda..."
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            size="large"
            autoFocus
          />
          <p
            style={{
              marginTop: "8px",
              fontSize: "12px",
              color: "#64748b"
            }}
          >
            Gunakan minimal 6 karakter kombinasi huruf dan angka untuk keamanan optimal.
          </p>
        </div>
      </Modal>
    </>
  );
};

export default Sidebar;